module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "s_loading"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/common/loading.svg"),
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c6530da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading/loading.vue
// module id = 315
// module chunks = 1